import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private tokenStorage: LocalStorageService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRoles = route.data['expectedRoles'] as string[];

    if (!expectedRoles || expectedRoles.length === 0) {
      return true;
    }

    const userRole = this.tokenStorage.getRole();

    if (!userRole || !expectedRoles.includes(userRole)) {
      this.router.navigate(['/home/dashboard']);
      return false;
    }

    return true;
  }
}
